import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { AppConfig } from "../constants/app.config";

@Injectable({
    providedIn: "root",
})
export class UtilityService {
    //Reusable methods defined in this Components
    data: any;
    chunkSize = 30;
    constructor(readonly http: HttpClient) {}

    //rewrite if iss url contains "DSTU2" string
    rebuild_DSTU2_STU3_Url(url: string) {
        if (url && url.includes("DSTU2")) {
            return url.replace("DSTU2", "STU3");
        }
        return url;
    }

    chunk(array: any[], size: number) {
        const chunkedArray = [];
        let index = 0;
        while (index < array.length) {
            chunkedArray.push(array.slice(index, size + index));
            index += size;
        }
        return chunkedArray;
    }

    bundleResources(resources: any) {
        let filteredEntries;
        let resourceArray = JSON.parse(resources);

        // to guard against "TypeError: resourceArray.filter is not a function" ...
        // parse again if JSON.parse() unexpectedly returned string
        if (typeof resourceArray === "string") {
            console.warn("UtilityService.bundleResources:  resourceArray is string, re-parsing");
            resourceArray = JSON.parse(resourceArray);
        }

        // Filter out any wrong resource types (and also ensure only include those that have effectiveDateTime - only for Observation)
        if (resourceArray) {
            filteredEntries = resourceArray.filter((entry: any) => {
              const hasCorrectResourceType = AppConfig.RESOURCE_TYPE.includes(entry.resource?.resourceType);
              const hasEffectiveDateTime = !!entry.resource?.effectiveDateTime || entry.resource?.resourceType !== 'Observation';
              return hasCorrectResourceType && hasEffectiveDateTime;
            });
        }
        if (filteredEntries) {
            return {
                entry: filteredEntries,
                total: filteredEntries.length,
                resourceType: "Bundle",
            };
        }
        return null;
    }

    /**
     * @param selectedEntries
     */

    //Updated selected entries for Observations Only.

    buildSelectedResources(selectedEntries: any[]) {
        const selectedResources: any[] = [];
        const flattenSelectedEntries = Array.prototype.concat.apply([], selectedEntries);

        flattenSelectedEntries.forEach(selectedEntry => {
            selectedResources.push(selectedEntry);
        });
        selectedResources.forEach(selectedEntry => {
                this.replaceReference(selectedEntry.resource);
        });
        return selectedResources;
    }

    replaceReference(object: any) {
        const baseUrl = localStorage.getItem("iss")?.replace(/\/+$/, "") || "";
        const localPatientId = localStorage.getItem("patient_local_id");
        const fhirVersion = localStorage.getItem("fhir_version") || "";

        const isAbsoluteReference = (ref: string): boolean => {
            return ref.startsWith('http://') || ref.startsWith('https://');
        };

        const isPatientReference = (ref: string): boolean => {
            return ref.includes('Patient/');
        };

        const getRelativeReference = (absoluteRef: string): string => {
            try {
                const url = new URL(absoluteRef);
                return url.pathname.split('/').slice(-2).join('/');
            } catch {
                return absoluteRef;
            }
        };

        const traverse = (obj: any) => {
            if (!obj || typeof obj !== "object") return;
            for (const key in obj) {
                if (key === "reference" && typeof obj[key] === "string") {
                    const ref = obj[key];

                    // Skip empty or invalid references
                    if (!ref || ref === '' || ref === 'InvalidReference') continue;

                    // Skip if already using full url reference
                    if (isAbsoluteReference(ref)) continue;

                    // Handle Patient references in R4 only if localPatientId available.
                    if (isPatientReference(ref) && fhirVersion.includes("R4") && localPatientId && localPatientId !== "null") {
                      obj[key] = `Patient/${localPatientId}`;
                    } else  { // All remaining cases - use full iss url
                            obj[key] = `${baseUrl}/${ref}`;
                    }
                } else {
                    traverse(obj[key]);
                }
            }
        };
        traverse(object);



        // Special handling for subject in R4
        if (fhirVersion.includes("R4") &&
            object.subject?.reference &&
            isPatientReference(object.subject.reference)) {
            object.subject.reference = `Patient/${localPatientId}`;
        }
    }
}
